/**
 * Generated by orval 🍺
 * Do not edit manually.
 * RepeatMD.PatientApp, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CashRewardRequest,
  DisplayGiveawayWeek,
  DisplayLoyaltyStatus,
  GetRewardByIdParams,
  InclusionListingsModel,
  PlatformUserRewardModel,
  ProblemDetails,
  PromoCodeModel,
  RedeemRewardInStoreModel,
  RedeemRewardRequest,
  RewardGetRewardInclusionsParams,
  RewardModel,
  RewardsParams
} from '../model';

import { customAxios } from '../../custom-axios';
import type { ErrorType } from '../../custom-axios';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Retrieve the current giveaway week for the signed-in user: the daily prizes, whether their
platform opted in, today's earned entries, and the custom category the giveaway links to.
 */
export const retrieveGiveawayWeek = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<DisplayGiveawayWeek>(
      {url: `/api/v1/giveaways/week`, method: 'GET', signal
    },
      options);
    }




export const getRetrieveGiveawayWeekQueryKey = () => {
    return [
    `/api/v1/giveaways/week`
    ] as const;
    }


export const getRetrieveGiveawayWeekQueryOptions = <TData = Awaited<ReturnType<typeof retrieveGiveawayWeek>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveGiveawayWeek>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRetrieveGiveawayWeekQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof retrieveGiveawayWeek>>> = ({ signal }) => retrieveGiveawayWeek(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof retrieveGiveawayWeek>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RetrieveGiveawayWeekQueryResult = NonNullable<Awaited<ReturnType<typeof retrieveGiveawayWeek>>>
export type RetrieveGiveawayWeekQueryError = ErrorType<unknown>


export function useRetrieveGiveawayWeek<TData = Awaited<ReturnType<typeof retrieveGiveawayWeek>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveGiveawayWeek>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveGiveawayWeek>>,
          TError,
          Awaited<ReturnType<typeof retrieveGiveawayWeek>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRetrieveGiveawayWeek<TData = Awaited<ReturnType<typeof retrieveGiveawayWeek>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveGiveawayWeek>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveGiveawayWeek>>,
          TError,
          Awaited<ReturnType<typeof retrieveGiveawayWeek>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRetrieveGiveawayWeek<TData = Awaited<ReturnType<typeof retrieveGiveawayWeek>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveGiveawayWeek>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieve the current giveaway week for the signed-in user: the daily prizes, whether their
platform opted in, today's earned entries, and the custom category the giveaway links to.
 */

export function useRetrieveGiveawayWeek<TData = Awaited<ReturnType<typeof retrieveGiveawayWeek>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveGiveawayWeek>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRetrieveGiveawayWeekQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Retrieve the signed-in client's loyalty status: their tier, progress toward the next one, and the program's
ladder and rules as the practice chose to show them. Not enabled, with nothing else set, when the practice runs
no loyalty program.
 */
export const retrieveLoyaltyStatus = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<DisplayLoyaltyStatus>(
      {url: `/api/v1/loyalty/status`, method: 'GET', signal
    },
      options);
    }




export const getRetrieveLoyaltyStatusQueryKey = () => {
    return [
    `/api/v1/loyalty/status`
    ] as const;
    }


export const getRetrieveLoyaltyStatusQueryOptions = <TData = Awaited<ReturnType<typeof retrieveLoyaltyStatus>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveLoyaltyStatus>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRetrieveLoyaltyStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof retrieveLoyaltyStatus>>> = ({ signal }) => retrieveLoyaltyStatus(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof retrieveLoyaltyStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RetrieveLoyaltyStatusQueryResult = NonNullable<Awaited<ReturnType<typeof retrieveLoyaltyStatus>>>
export type RetrieveLoyaltyStatusQueryError = ErrorType<unknown>


export function useRetrieveLoyaltyStatus<TData = Awaited<ReturnType<typeof retrieveLoyaltyStatus>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveLoyaltyStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveLoyaltyStatus>>,
          TError,
          Awaited<ReturnType<typeof retrieveLoyaltyStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRetrieveLoyaltyStatus<TData = Awaited<ReturnType<typeof retrieveLoyaltyStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveLoyaltyStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof retrieveLoyaltyStatus>>,
          TError,
          Awaited<ReturnType<typeof retrieveLoyaltyStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRetrieveLoyaltyStatus<TData = Awaited<ReturnType<typeof retrieveLoyaltyStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveLoyaltyStatus>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieve the signed-in client's loyalty status: their tier, progress toward the next one, and the program's
ladder and rules as the practice chose to show them. Not enabled, with nothing else set, when the practice runs
no loyalty program.
 */

export function useRetrieveLoyaltyStatus<TData = Awaited<ReturnType<typeof retrieveLoyaltyStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof retrieveLoyaltyStatus>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRetrieveLoyaltyStatusQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Record that the signed-in client was shown the celebration of a tier they earned, so the app does not show it
again. Recording it twice changes nothing; another client's status answers 404.
 */
export const recordLoyaltyPromotionCelebrated = (
    loyaltyStatusId: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/loyalty/status/${loyaltyStatusId}/celebrated`, method: 'POST', signal
    },
      options);
    }




export const getRecordLoyaltyPromotionCelebratedMutationKey = () => ['recordLoyaltyPromotionCelebrated'] as const;

export const getRecordLoyaltyPromotionCelebratedMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordLoyaltyPromotionCelebrated>>, TError,RecordLoyaltyPromotionCelebratedMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof recordLoyaltyPromotionCelebrated>>, TError,RecordLoyaltyPromotionCelebratedMutationVariables, TContext> => {

const mutationKey = getRecordLoyaltyPromotionCelebratedMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recordLoyaltyPromotionCelebrated>>, RecordLoyaltyPromotionCelebratedMutationVariables> = (props) => {
          const {loyaltyStatusId} = props ?? {};

          return  recordLoyaltyPromotionCelebrated(loyaltyStatusId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RecordLoyaltyPromotionCelebratedMutationResult = NonNullable<Awaited<ReturnType<typeof recordLoyaltyPromotionCelebrated>>>

    export type RecordLoyaltyPromotionCelebratedMutationError = ErrorType<ProblemDetails>
    export type RecordLoyaltyPromotionCelebratedMutationVariables = {loyaltyStatusId: string}

    /**
 * @summary Record that the signed-in client was shown the celebration of a tier they earned, so the app does not show it
again. Recording it twice changes nothing; another client's status answers 404.
 */
export const useRecordLoyaltyPromotionCelebrated = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordLoyaltyPromotionCelebrated>>, TError,RecordLoyaltyPromotionCelebratedMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof recordLoyaltyPromotionCelebrated>>,
        TError,
        RecordLoyaltyPromotionCelebratedMutationVariables,
        TContext
      > => {
      return useMutation(getRecordLoyaltyPromotionCelebratedMutationOptions(options), queryClient);
    }
    /**
 * @summary Retrieve a specific PromoCode if you have access to it at your Location
 */
export const getPromoCode = (
    promoCodeId: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PromoCodeModel>(
      {url: `/api/v1/promoCodes/${promoCodeId}`, method: 'GET', signal
    },
      options);
    }




export const getGetPromoCodeQueryKey = (promoCodeId: string,) => {
    return [
    `/api/v1/promoCodes/${promoCodeId}`
    ] as const;
    }


export const getGetPromoCodeQueryOptions = <TData = Awaited<ReturnType<typeof getPromoCode>>, TError = ErrorType<unknown>>(promoCodeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromoCode>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPromoCodeQueryKey(promoCodeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPromoCode>>> = ({ signal }) => getPromoCode(promoCodeId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: promoCodeId !== null && promoCodeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPromoCode>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPromoCodeQueryResult = NonNullable<Awaited<ReturnType<typeof getPromoCode>>>
export type GetPromoCodeQueryError = ErrorType<unknown>


export function useGetPromoCode<TData = Awaited<ReturnType<typeof getPromoCode>>, TError = ErrorType<unknown>>(
 promoCodeId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromoCode>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPromoCode>>,
          TError,
          Awaited<ReturnType<typeof getPromoCode>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPromoCode<TData = Awaited<ReturnType<typeof getPromoCode>>, TError = ErrorType<unknown>>(
 promoCodeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromoCode>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPromoCode>>,
          TError,
          Awaited<ReturnType<typeof getPromoCode>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPromoCode<TData = Awaited<ReturnType<typeof getPromoCode>>, TError = ErrorType<unknown>>(
 promoCodeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromoCode>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieve a specific PromoCode if you have access to it at your Location
 */

export function useGetPromoCode<TData = Awaited<ReturnType<typeof getPromoCode>>, TError = ErrorType<unknown>>(
 promoCodeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPromoCode>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPromoCodeQueryOptions(promoCodeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Returns the number of available and upcoming rewards.
 */
export const rewards = (
    params?: RewardsParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<RewardModel[]>(
      {url: `/api/v1/rewards`, method: 'GET',
        params, signal
    },
      options);
    }




export const getRewardsQueryKey = (params?: RewardsParams,) => {
    return [
    `/api/v1/rewards`, ...(params ? [params] : [])
    ] as const;
    }


export const getRewardsQueryOptions = <TData = Awaited<ReturnType<typeof rewards>>, TError = ErrorType<void>>(params?: RewardsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rewards>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRewardsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof rewards>>> = ({ signal }) => rewards(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof rewards>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RewardsQueryResult = NonNullable<Awaited<ReturnType<typeof rewards>>>
export type RewardsQueryError = ErrorType<void>


export function useRewards<TData = Awaited<ReturnType<typeof rewards>>, TError = ErrorType<void>>(
 params: undefined |  RewardsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof rewards>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof rewards>>,
          TError,
          Awaited<ReturnType<typeof rewards>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRewards<TData = Awaited<ReturnType<typeof rewards>>, TError = ErrorType<void>>(
 params?: RewardsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rewards>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof rewards>>,
          TError,
          Awaited<ReturnType<typeof rewards>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRewards<TData = Awaited<ReturnType<typeof rewards>>, TError = ErrorType<void>>(
 params?: RewardsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rewards>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns the number of available and upcoming rewards.
 */

export function useRewards<TData = Awaited<ReturnType<typeof rewards>>, TError = ErrorType<void>>(
 params?: RewardsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rewards>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRewardsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Redeems a reward after verifying the user is eligible to do so.
 */
export const redeem = (
    redeemRewardRequest: RedeemRewardRequest,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<RewardModel>(
      {url: `/api/v1/rewards/redeem`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: redeemRewardRequest, signal
    },
      options);
    }




export const getRedeemMutationKey = () => ['redeem'] as const;

export const getRedeemMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof redeem>>, TError,RedeemMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof redeem>>, TError,RedeemMutationVariables, TContext> => {

const mutationKey = getRedeemMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof redeem>>, RedeemMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  redeem(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RedeemMutationResult = NonNullable<Awaited<ReturnType<typeof redeem>>>
    export type RedeemMutationBody = RedeemRewardRequest
    export type RedeemMutationError = ErrorType<void>
    export type RedeemMutationVariables = {data: RedeemRewardRequest}

    /**
 * @summary Redeems a reward after verifying the user is eligible to do so.
 */
export const useRedeem = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof redeem>>, TError,RedeemMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof redeem>>,
        TError,
        RedeemMutationVariables,
        TContext
      > => {
      return useMutation(getRedeemMutationOptions(options), queryClient);
    }
    /**
 * @summary Returns a single Reward by Id. Status is not calculated (0) to save expensive resources.
 */
export const getRewardById = (
    rewardId: string,
    params?: GetRewardByIdParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<RewardModel>(
      {url: `/api/v1/rewards/${rewardId}`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetRewardByIdQueryKey = (rewardId: string,
    params?: GetRewardByIdParams,) => {
    return [
    `/api/v1/rewards/${rewardId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetRewardByIdQueryOptions = <TData = Awaited<ReturnType<typeof getRewardById>>, TError = ErrorType<unknown>>(rewardId: string,
    params?: GetRewardByIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRewardById>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRewardByIdQueryKey(rewardId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRewardById>>> = ({ signal }) => getRewardById(rewardId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: rewardId !== null && rewardId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRewardById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRewardByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getRewardById>>>
export type GetRewardByIdQueryError = ErrorType<unknown>


export function useGetRewardById<TData = Awaited<ReturnType<typeof getRewardById>>, TError = ErrorType<unknown>>(
 rewardId: string,
    params: undefined |  GetRewardByIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRewardById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRewardById>>,
          TError,
          Awaited<ReturnType<typeof getRewardById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRewardById<TData = Awaited<ReturnType<typeof getRewardById>>, TError = ErrorType<unknown>>(
 rewardId: string,
    params?: GetRewardByIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRewardById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRewardById>>,
          TError,
          Awaited<ReturnType<typeof getRewardById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRewardById<TData = Awaited<ReturnType<typeof getRewardById>>, TError = ErrorType<unknown>>(
 rewardId: string,
    params?: GetRewardByIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRewardById>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns a single Reward by Id. Status is not calculated (0) to save expensive resources.
 */

export function useGetRewardById<TData = Awaited<ReturnType<typeof getRewardById>>, TError = ErrorType<unknown>>(
 rewardId: string,
    params?: GetRewardByIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRewardById>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRewardByIdQueryOptions(rewardId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Endpoint to cash in a reward.
 */
export const cashInReward = (
    cashRewardRequest: CashRewardRequest,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PlatformUserRewardModel>(
      {url: `/api/v1/rewards/cash`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: cashRewardRequest, signal
    },
      options);
    }




export const getCashInRewardMutationKey = () => ['cashInReward'] as const;

export const getCashInRewardMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cashInReward>>, TError,CashInRewardMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof cashInReward>>, TError,CashInRewardMutationVariables, TContext> => {

const mutationKey = getCashInRewardMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cashInReward>>, CashInRewardMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  cashInReward(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CashInRewardMutationResult = NonNullable<Awaited<ReturnType<typeof cashInReward>>>
    export type CashInRewardMutationBody = CashRewardRequest
    export type CashInRewardMutationError = ErrorType<unknown>
    export type CashInRewardMutationVariables = {data: CashRewardRequest}

    /**
 * @summary Endpoint to cash in a reward.
 */
export const useCashInReward = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cashInReward>>, TError,CashInRewardMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cashInReward>>,
        TError,
        CashInRewardMutationVariables,
        TContext
      > => {
      return useMutation(getCashInRewardMutationOptions(options), queryClient);
    }
    /**
 * @summary Redeems a reward with QR code after verifying the user is eligible to do so.
 */
export const redeemInStore = (
    redeemRewardInStoreModel: RedeemRewardInStoreModel,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<RewardModel>(
      {url: `/api/v1/rewards/redeem-in-store`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: redeemRewardInStoreModel, signal
    },
      options);
    }




export const getRedeemInStoreMutationKey = () => ['redeemInStore'] as const;

export const getRedeemInStoreMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof redeemInStore>>, TError,RedeemInStoreMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof redeemInStore>>, TError,RedeemInStoreMutationVariables, TContext> => {

const mutationKey = getRedeemInStoreMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof redeemInStore>>, RedeemInStoreMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  redeemInStore(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RedeemInStoreMutationResult = NonNullable<Awaited<ReturnType<typeof redeemInStore>>>
    export type RedeemInStoreMutationBody = RedeemRewardInStoreModel
    export type RedeemInStoreMutationError = ErrorType<void>
    export type RedeemInStoreMutationVariables = {data: RedeemRewardInStoreModel}

    /**
 * @summary Redeems a reward with QR code after verifying the user is eligible to do so.
 */
export const useRedeemInStore = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof redeemInStore>>, TError,RedeemInStoreMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof redeemInStore>>,
        TError,
        RedeemInStoreMutationVariables,
        TContext
      > => {
      return useMutation(getRedeemInStoreMutationOptions(options), queryClient);
    }
    /**
 * @summary Returns a list of referrable Rewards. Will order by MinimumVisits.
 */
export const getReferrableRewards = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<RewardModel[]>(
      {url: `/api/v1/rewards/referrable`, method: 'GET', signal
    },
      options);
    }




export const getGetReferrableRewardsQueryKey = () => {
    return [
    `/api/v1/rewards/referrable`
    ] as const;
    }


export const getGetReferrableRewardsQueryOptions = <TData = Awaited<ReturnType<typeof getReferrableRewards>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferrableRewards>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReferrableRewardsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReferrableRewards>>> = ({ signal }) => getReferrableRewards(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReferrableRewards>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReferrableRewardsQueryResult = NonNullable<Awaited<ReturnType<typeof getReferrableRewards>>>
export type GetReferrableRewardsQueryError = ErrorType<unknown>


export function useGetReferrableRewards<TData = Awaited<ReturnType<typeof getReferrableRewards>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferrableRewards>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReferrableRewards>>,
          TError,
          Awaited<ReturnType<typeof getReferrableRewards>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReferrableRewards<TData = Awaited<ReturnType<typeof getReferrableRewards>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferrableRewards>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReferrableRewards>>,
          TError,
          Awaited<ReturnType<typeof getReferrableRewards>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReferrableRewards<TData = Awaited<ReturnType<typeof getReferrableRewards>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferrableRewards>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns a list of referrable Rewards. Will order by MinimumVisits.
 */

export function useGetReferrableRewards<TData = Awaited<ReturnType<typeof getReferrableRewards>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReferrableRewards>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetReferrableRewardsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Returns the inclusion listings for a reward, scoped to the platform user's location.
 */
export const rewardGetRewardInclusions = (
    rewardId: string,
    params?: RewardGetRewardInclusionsParams,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<InclusionListingsModel>(
      {url: `/api/v1/rewards/${rewardId}/inclusions`, method: 'GET',
        params, signal
    },
      options);
    }




export const getRewardGetRewardInclusionsQueryKey = (rewardId: string,
    params?: RewardGetRewardInclusionsParams,) => {
    return [
    `/api/v1/rewards/${rewardId}/inclusions`, ...(params ? [params] : [])
    ] as const;
    }


export const getRewardGetRewardInclusionsQueryOptions = <TData = Awaited<ReturnType<typeof rewardGetRewardInclusions>>, TError = ErrorType<unknown>>(rewardId: string,
    params?: RewardGetRewardInclusionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rewardGetRewardInclusions>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRewardGetRewardInclusionsQueryKey(rewardId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof rewardGetRewardInclusions>>> = ({ signal }) => rewardGetRewardInclusions(rewardId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: rewardId !== null && rewardId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof rewardGetRewardInclusions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RewardGetRewardInclusionsQueryResult = NonNullable<Awaited<ReturnType<typeof rewardGetRewardInclusions>>>
export type RewardGetRewardInclusionsQueryError = ErrorType<unknown>


export function useRewardGetRewardInclusions<TData = Awaited<ReturnType<typeof rewardGetRewardInclusions>>, TError = ErrorType<unknown>>(
 rewardId: string,
    params: undefined |  RewardGetRewardInclusionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof rewardGetRewardInclusions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof rewardGetRewardInclusions>>,
          TError,
          Awaited<ReturnType<typeof rewardGetRewardInclusions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRewardGetRewardInclusions<TData = Awaited<ReturnType<typeof rewardGetRewardInclusions>>, TError = ErrorType<unknown>>(
 rewardId: string,
    params?: RewardGetRewardInclusionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rewardGetRewardInclusions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof rewardGetRewardInclusions>>,
          TError,
          Awaited<ReturnType<typeof rewardGetRewardInclusions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRewardGetRewardInclusions<TData = Awaited<ReturnType<typeof rewardGetRewardInclusions>>, TError = ErrorType<unknown>>(
 rewardId: string,
    params?: RewardGetRewardInclusionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rewardGetRewardInclusions>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Returns the inclusion listings for a reward, scoped to the platform user's location.
 */

export function useRewardGetRewardInclusions<TData = Awaited<ReturnType<typeof rewardGetRewardInclusions>>, TError = ErrorType<unknown>>(
 rewardId: string,
    params?: RewardGetRewardInclusionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof rewardGetRewardInclusions>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRewardGetRewardInclusionsQueryOptions(rewardId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






